import NonJoinerAnalytics from 'routes/NonJoinerAnalytics/NonJoinerAnalytics';

export default NonJoinerAnalytics;
